import { CommonEnums } from '../../common.enums';
export class Select_Inst {
    dxMp_Id: number;
    select_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    updateDt: Date;
    updateBy: string;
    persistFlg: string;
    attr_Tab_Valid_Cd: string;
    format: string;

    constructor() {
        this.setDefaults()
    }
    setDefaults() {
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.select_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.flag.YES;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.format = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(object: any): Select_Inst {
        let select_Inst: Select_Inst = new Select_Inst();
        select_Inst.copyFrom(object as Select_Inst);
        return select_Inst;
    }

    copy(): Select_Inst {
        let select_InstTmp: Select_Inst = new Select_Inst();

        select_InstTmp.dxMp_Id = this.dxMp_Id;
        select_InstTmp.select_Inst_Id = this.select_Inst_Id;
        select_InstTmp.nm = this.nm
        select_InstTmp.description = this.description;
        select_InstTmp.ver = this.ver;
        select_InstTmp.valid_Cd = this.valid_Cd;
        select_InstTmp.updateDt = this.updateDt;
        select_InstTmp.updateBy = this.updateBy;
        select_InstTmp.persistFlg = this.persistFlg;
        select_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        select_InstTmp.format = this.format;

        return select_InstTmp;
    }
    copyFrom(select_InstTmp: Select_Inst): void {

        this.dxMp_Id = select_InstTmp.dxMp_Id;
        this.select_Inst_Id = select_InstTmp.select_Inst_Id;
        this.nm = select_InstTmp.nm;
        this.description = select_InstTmp.description;
        this.ver = select_InstTmp.ver;
        this.valid_Cd = select_InstTmp.valid_Cd;
        this.updateDt = select_InstTmp.updateDt;
        this.updateBy = select_InstTmp.updateBy;
        this.persistFlg = select_InstTmp.persistFlg
        this.attr_Tab_Valid_Cd = select_InstTmp.attr_Tab_Valid_Cd;
        this.format = select_InstTmp.format;

    }
    compare(select_InstTmp: Select_Inst): string {
        let select_InstString: string = this.toString();
        let select_InstTmpString: string = select_InstTmp.toString();

        if (select_InstString != select_InstTmpString) {
            return select_InstString + ', ' + select_InstTmpString;
        }

        return '';
    }
    toString(isNotCompare: boolean = true): string {
        let str: string = "Select_Inst [dxMp_Id=" + this.dxMp_Id + ", select_Inst_Id=" + this.select_Inst_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", ver=" + this.ver +
            ",valid_Cd="+ this.valid_Cd +", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy + ", persistFlg=" + this.persistFlg + ",attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd
            + ",format=" + this.format;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}




